import React, { Component } from "react";
import { Spin, Modal, Row, Col, Form, Button, Input, message } from "antd";
import AdCampaignView from "./AdCampaignView";
import {
  getAdCampaigns,
  getPhysicalClinicList,
  updateCampaignStatus
} from "../../services";
import { showSuccessNotification, showErrorNotification } from "../../helpers";

const FormItem = Form.Item;
class AdCampaignContainer extends Component {
  state = {
    adCampaigns: [],
    pageNo: 1,
    perPage: 10,
    isProcessing: false,
    allRecords: 0,
    showDescription: false,
    selectedRecord: null,
    clinics: [],
    filterParams: {
      clinicId: null
    },
    showEditModal: false,
    selectedCampaign: null,
    facebookCampaignId: null,
    googleCampaignId: null,
    googleCustomerId: null
  };

  componentDidMount() {
    this.fetchClinicsList();
    this.fetchAdCampaigns();
  }

  fetchClinicsList = searchText => {
    const { pageNo } = this.state;
    getPhysicalClinicList(pageNo, searchText || null, false).then(response => {
      this.setState({
        isProcessing: false
      });
      if (response?.data?.success) {
        const { clinics } = response.data.data;
        this.setState({
          clinics
        });
      } else {
        this.setState({
          clinics: []
        });
      }
    });
  };

  fetchAdCampaigns = () => {
    const { pageNo, perPage, filterParams } = this.state;
    this.setState({ isProcessing: true });
    getAdCampaigns(pageNo, perPage, filterParams).then(response => {
      this.setState({ isProcessing: false });
      if (response?.data?.data?.length > 0) {
        // const adCampaigns = [];
        // response.data.data.map(obj => {
        //   adCampaigns.push(obj.attributes);
        // });
        this.setState({
          adCampaigns: this.addCampaginsData(
            response.data.data,
            response.data.included
          ),
          allRecords: response.data.meta.total_records
        });
      } else {
        this.setState({ adCampaigns: [], allRecords: 0 });
      }
    });
  };

  addCampaginsData = (data, included) => {
    data.map(dataElement => {
      const socialDataArr =
        dataElement?.relationships?.ad_campaign_socials?.data || [];

      if (socialDataArr.length > 0) {
        let socialPlatforms = [];

        socialDataArr.map(socialElement => {
          const dataIndex = included.findIndex(
            incElement =>
              incElement.type == "ad_campaign_social" &&
              incElement.id == socialElement.id
          );

          if (dataIndex !== -1) {
            socialPlatforms.push(included[dataIndex]);
          }
        });
        dataElement.attributes.socialPlatforms = socialPlatforms;
      }
    });

    return data;
  };

  onPageChange = page => {
    this.setState({ pageNo: page, adCampaigns: [] }, () => {
      this.fetchAdCampaigns();
    });
  };

  handleChangePageSizeChange = (current, size) => {
    this.setState({ perPage: size, pageNo: 1 }, () => {
      this.fetchAdCampaigns();
    });
  };

  handleViewDescription = (e, record) => {
    if (e) e.preventDefault();
    const { showDescription } = this.state;
    this.setState({
      showDescription: !showDescription,
      selectedRecord: record
    });
  };

  handleCloseDescModal = () => {
    this.setState({ showDescription: false, selectedRecord: null });
  };

  handleToggleActivation = (enableStatus, record) => {
    const params = {
      id: record.attributes.id,
      active: enableStatus,
      campaign_status: record.attributes.campaign_status
    };
    if (!enableStatus) {
      // user choose to turf off the active state, then ask for confirmation
      Modal.confirm({
        title: `Deactivate campaign?`,
        content: (
          <div>{`Are you sure you want to de-active the campaign page?`}</div>
        ),
        onOk: () => {
          this.handleUpdateCampaignStatus(params);
        }
      });
    } else {
      this.handleUpdateCampaignStatus(params);
    }
  };

  handleSelectClinic = (clinicId = null) => {
    this.setState(
      { filterParams: { ...this.state.filterParams, clinicId: clinicId } },
      () => {
        this.fetchAdCampaigns();
      }
    );
  };

  handleUpdateCampaignStatus = params => {
    updateCampaignStatus(params).then(response => {
      if (response?.data?.success) {
        this.fetchAdCampaigns();
      }
    });
  };

  handleChangeStatus = (val, record) => {
    const params = {
      id: record.attributes.id,
      campaign_status: val
    };
    this.handleUpdateCampaignStatus(params);
  };

  handleEditCampaign = record => {
    const facebookCampaign =
      record?.attributes?.socialPlatforms?.length > 0
        ? record?.attributes?.socialPlatforms.filter(
            platform => platform.attributes.platform === "facebook"
          )
        : [];
    const googleCampaign =
      record?.attributes?.socialPlatforms?.length > 0
        ? record?.attributes?.socialPlatforms.filter(
            platform => platform.attributes.platform === "google"
          )
        : [];

    this.setState({
      showEditModal: true,
      selectedCampaign: record,
      facebookCampaignId:
        facebookCampaign.length > 0
          ? facebookCampaign[0].attributes.platform_campaign_id
          : null,
      googleCampaignId:
        googleCampaign.length > 0
          ? googleCampaign[0].attributes.platform_campaign_id
          : null,
      googleCustomerId:
        googleCampaign.length > 0
          ? googleCampaign[0].attributes.platform_customer_id
          : null
    });
  };

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedCampaign: null,
      facebookCampaignId: null,
      googleCampaignId: null
    });
  };

  handleSubmit = e => {
    if (e) e.preventDefault();
    const {
      facebookCampaignId,
      googleCampaignId,
      selectedCampaign,
      googleCustomerId
    } = this.state;

    this.setState({ isProcessing: true });

    const params = {
      id: selectedCampaign?.id
    };
    params.social_platforms = [];

    if (facebookCampaignId) {
      const obj = {
        platform: "facebook",
        platform_campaign_id: facebookCampaignId
      };

      // in case of edit
      const facebookCampaign =
        selectedCampaign?.attributes?.socialPlatforms?.length > 0
          ? selectedCampaign?.attributes?.socialPlatforms.filter(
              platform => platform.attributes.platform === "facebook"
            )
          : [];

      if (facebookCampaign.length > 0) {
        obj.id = facebookCampaign[0].id;
      }

      params.social_platforms.push(obj);
    }

    if (googleCampaignId) {
      if (!googleCustomerId) {
        showErrorNotification("Please enter your Google customer Id.");
        return false;
      } else {
        const obj = {
          platform: "google",
          platform_campaign_id: googleCampaignId,
          platform_customer_id: googleCustomerId.replace(/-/g, "")
        };
        // in case of edit
        const googleCampaign =
          selectedCampaign?.attributes?.socialPlatforms?.length > 0
            ? selectedCampaign?.attributes?.socialPlatforms.filter(
                platform => platform.attributes.platform === "google"
              )
            : [];

        if (googleCampaign.length > 0) {
          obj.id = googleCampaign[0].id;
        }
        params.social_platforms.push(obj);
      }
    }

    updateCampaignStatus(params)
      .then(response => {
        if (response?.data?.success) {
          this.handleCloseEditModal();
          showSuccessNotification("Campaign updated successfully");
          this.fetchAdCampaigns();
        } else {
          showErrorNotification(response.data.errors[0].title);
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  handleInputChange = (value, name) => {
    this.setState({ [name]: value });
  };

  handleLinkCopyClick = e => {
    if (e) e.preventDefault();
    message.success("Link copied!");
  };

  render() {
    const {
      isProcessing,
      adCampaigns,
      allRecords,
      pageNo,
      perPage,
      selectedRecord,
      showDescription,
      clinics,
      showEditModal,
      facebookCampaignId,
      googleCampaignId,
      googleCustomerId
    } = this.state;
    return (
      <Spin spinning={isProcessing}>
        <AdCampaignView
          adCampaigns={adCampaigns}
          allRecords={allRecords}
          pageNo={pageNo}
          perPage={perPage}
          onPageChange={this.onPageChange}
          handleChangePageSizeChange={this.handleChangePageSizeChange}
          handleViewDescription={this.handleViewDescription}
          handleToggleActivation={this.handleToggleActivation}
          clinics={clinics}
          fetchClinicsList={this.fetchClinicsList}
          handleSelectClinic={this.handleSelectClinic}
          handleChangeStatus={this.handleChangeStatus}
          handleEditCampaign={this.handleEditCampaign}
          handleLinkCopyClick={this.handleLinkCopyClick}
        />

        <Modal
          title="View description"
          visible={showDescription}
          onCancel={this.handleCloseDescModal}
          centered
          footer={null}
        >
          <p>
            {selectedRecord?.attributes?.description ||
              "No description added by the owner"}
          </p>
        </Modal>

        <Modal
          title="Edit campaign"
          visible={showEditModal}
          onCancel={this.handleCloseEditModal}
          centered
          footer={null}
        >
          <Form layout="vertical" onSubmit={this.handleSubmit}>
            <FormItem label="Facebook campaign Id">
              <Input
                value={facebookCampaignId}
                onChange={e =>
                  this.handleInputChange(e.target.value, "facebookCampaignId")
                }
              />
            </FormItem>
            <FormItem label="Google campaign Id">
              <Input
                value={googleCampaignId}
                onChange={e =>
                  this.handleInputChange(e.target.value, "googleCampaignId")
                }
              />
            </FormItem>
            <FormItem label="Google customer Id">
              <Input
                value={googleCustomerId}
                onChange={e =>
                  this.handleInputChange(e.target.value, "googleCustomerId")
                }
              />
            </FormItem>

            <FormItem>
              <Row type="flex" gutter={20}>
                <Col>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isProcessing}
                  >
                    Submit
                  </Button>
                </Col>
                <Col>
                  <Button onClick={this.handleCloseEditModal}>Cancel</Button>
                </Col>
              </Row>
            </FormItem>
          </Form>
        </Modal>
      </Spin>
    );
  }
}

export default AdCampaignContainer;
